export const SNACKBAR_OPEN = "SNACKBAR_OPEN";

export const openSnackBar = data => ({
  type: SNACKBAR_OPEN,
  ...data,
  open: true
});

export const SNACKBAR_CLOSE = "SNACKBAR_CLOSE";

export const closeSnackBar = data => ({
  type: SNACKBAR_CLOSE,
  open: false
});
